import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: []
})
export class BillingComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/billing.component.ts